import React, { useCallback, useEffect, useState } from 'react';
import { Container, Row, Stack } from 'react-bootstrap';
import { asve } from '../shared/orve';
import {
  getAssessmentContentBlank,
  getAssessmentText,
  getCandidateLeaderText,
  getCandidateValuesText,
} from '../shared/report-util';
import { useAuth } from '../../../providers/auth-provider';
import { REPORT_TYPE } from '../../../utils/constants';

const valuesBreaks = {
  breaks: [3, 2],
  scale: 3,
};

function NewHireCoachingValuesAligned({ candidate, start, max, reportType = REPORT_TYPE.coaching }) {
  const { isSelect } = useAuth();
  const [assessmentText, setAssessmentText] = useState({});

  const displayPage = useCallback(() => {
    if (start === 0) {
      return true;
    }

    if (candidate?.values.aligned?.length > 0) {
      if (start < candidate?.values.aligned?.length) {
        return true;
      }
    }

    return false;
  }, [candidate]);

  useEffect(() => {
    if (candidate) {
      setAssessmentText(asve(candidate));
    }
  }, [candidate]);

  return (
    <>
      {displayPage() && (
        <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
          {candidate && (
            <>
              <Container className="candidate-profile-assessment-content">
                <Row className="w-50 justify-content-left">
                  <h3 className="pt-4 pb-1">{getCandidateValuesText(isSelect()).toUpperCase()}</h3>
                </Row>
                {start === 0 && candidate?.values.aligned?.length > 0 && (
                  <Row className="w-100 mx-auto pt-4 pb-2">
                    Below is a list of{` ${getCandidateValuesText(isSelect(), true)} `}where there is strong alignment
                    between the
                    {` ${getCandidateLeaderText(isSelect())} `}and the Organization (i.e., the
                    {` ${getCandidateValuesText(isSelect(), true)} `}with the strongest alignment).
                  </Row>
                )}
                {start === 0 && candidate?.values.aligned?.length === 0 && (
                  <Row className="w-100 mx-auto pt-4 pb-2">
                    There were no{` ${getCandidateValuesText(isSelect(), true)} `}where there is strong alignment
                    between the
                    {` ${getCandidateLeaderText(isSelect())} `}and the Organization (i.e., the
                    {` ${getCandidateValuesText(isSelect(), true)} `}with the strongest alignment).
                  </Row>
                )}
                {start > 0 && (
                  <Row className="w-100 mx-auto pt-4 pb-2">
                    Continued below is a list of{` ${getCandidateValuesText(isSelect(), true)} `}where there is strong
                    alignment between the
                    {` ${getCandidateLeaderText(isSelect())} `} and the Organization (i.e., the
                    {` ${getCandidateValuesText(isSelect(), true)} `}with the strongest alignment).
                  </Row>
                )}
                <Row className="w-100 mx-auto justify-content-center pt-3">
                  {candidate?.values.aligned.slice(start, max).map((key) => {
                    return (
                      <Stack direction="horizontal" className="subscore-chart" key={key}>
                        <div className="w-25">
                          {getAssessmentContentBlank(
                            candidate.values.titles[key],
                            candidate.values.ratings[key],
                            valuesBreaks,
                            reportType
                          )}
                        </div>
                        <div className="w-75">{getAssessmentText(assessmentText[key])}</div>
                      </Stack>
                    );
                  })}
                </Row>
              </Container>
            </>
          )}
        </Container>
      )}
    </>
  );
}

export default NewHireCoachingValuesAligned;
